/** Physical source identities remain stable; only their delivery URL changes. */
const packedUrls = new Map<string, string>();
const deferredUrls = new Map<string, string>();
const deferredSources = new Map<string, string>();
let revision = 0;

export const packedAssetUrl = (path: string): string | undefined => packedUrls.get(path) ?? deferredUrls.get(path);
export const deferredAssetSource = (url: string): string | undefined => deferredSources.get(url);
export const packedAssetRevision = (): number => revision;

/** Native DOM/CSS must not race the same required images as individual HTTP
 * requests. A reversible transparent URL lets the entry art appear as its pack
 * arrives, without waiting for the rest of the game to decode. */
export function deferPackedImages(paths: Iterable<string>): void {
  for (const path of paths) {
    if (deferredUrls.has(path)) continue;
    const url = `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%221%22%20height%3D%221%22%2F%3E#${encodeURIComponent(path)}`;
    deferredUrls.set(path, url);
    deferredSources.set(url, path);
  }
}
export function registerPackedAsset(path: string, blob: Blob): string {
  const existing = packedUrls.get(path);
  if (existing) return existing;
  const url = URL.createObjectURL(blob);
  packedUrls.set(path, url);
  revision++;
  return url;
}
